import React from "react";

export default () => {
  return (
    <div className="h-screen w-screen flex items-center justify-center">
      Lo Sentimos ha ocurrido un error :(
    </div>
  );
};
